<template>
  <v-data-table v-bind="$props" v-on="$listeners" :search="search">
    <template v-slot:progress>
      <ProgressLinearTimeout />
    </template>
    <template v-slot:top>
      <v-row>
        <v-col cols="2">
          <v-btn
            class="ml-2"
            color="success"
            data-cy="TableBasic-button-new"
            @click="$emit('new')"
          >
            <v-icon class="mr-2">
              {{ mdiPlus }}
            </v-icon>
            {{ $t('common.buttons.new') }}
          </v-btn>
        </v-col>
        <v-col cols="4">
          <slot name="filters" />
        </v-col>
        <v-col cols="6">
          <v-text-field
            clearable
            data-cy="TableBasic-search"
            class="mr-2"
            v-model="search"
            :append-icon="mdiMagnify"
            :label="$t('common.search')"
            single-line
            hide-details
          />
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { VDataTable } from 'vuetify/lib';
import { mdiPlus, mdiMagnify } from '@mdi/js';
import ProgressLinearTimeout from './ProgressLinearTimeout.vue';

export default {
  name: 'TableBasic',
  extends: VDataTable,
  components: {
    ProgressLinearTimeout,
  },
  data() {
    return {
      // icons
      mdiPlus,
      mdiMagnify,
      // data
      search: '',
    };
  },
};
</script>
